import {
  clearFromRoute,
  clearToRoute,
  setDepartureTime,
  setFromForRoute,
  setToForRoute,
} from '../../../googleMaps/route.js';
import { specialAddresses } from '../../../i18n/specialAdresses.js';
import { loadLs, saveLs } from '../../../storage/localStorage.js';
import { setTripOrderData } from '../orderData.js';
import {
  changeBgColor,
  changeInputsStyled,
} from './utils/changeInputsStyled.js';
import { insertsSpecialAddresses } from './utils/insertsSpecialAddresses.js';
import { getPlaceByGeocode } from './utils/getPlaceByGeocode.js';
import { notify } from '../../toastify/toastify.js';
import { isInPragueAirport } from '../../../googleMaps/map.js';

const initialTripData = {
  time: '',
  from: null,
  to: null,
  distance: {
    value: null,
    text: '',
  },
  duration: {
    value: null,
    text: '',
  },
  flightNumber: null,
};

export let tripData = initialTripData;
const KEY_LS = 'trip-data';

// =====================================
// Функція для оновлення tripData і збереження в localStorage
// =====================================
export const setTripData = data => {
  Object.assign(tripData, data);
  saveLs(KEY_LS, tripData);
  setTripOrderData(tripData);
  if (flightNumberWrapper && data?.from) {
    const hasCoords = !!data.from.coords;
    const address = data.from.address || '';
    const addressEmpty = address.trim() === '';

    if (addressEmpty) {
      flightNumberWrapper.style.display = 'none';
      tripData.flightNumber = null;
      if (flightNumberField) {
        flightNumberField.value = '';
        changeBgColor(flightNumberField, '#fff');
      }
      return;
    }

    if (hasCoords && isInPragueAirport(data.from.coords)) {
      flightNumberWrapper.style.display = 'block';
    } else {
      flightNumberWrapper.style.display = 'none';
    }
  }
};

// =====================================
// Селектори
// =====================================
const refs = {
  form: document.querySelector('form'),
  inputTime: document.getElementById('time'),
  fromInput: document.getElementById('get-in'),
  toInput: document.getElementById('get-out'),
  lang: document.documentElement.lang || 'en',
  flightNumberWrapper: document.getElementById('flightNumberWrapper'),
  flightNumberField: document.getElementById('flightNumberField'),
};

const {
  form,
  inputTime,
  fromInput,
  toInput,
  lang,
  flightNumberWrapper,
  flightNumberField,
} = refs;

// =====================================
// Відновлення даних з localStorage
// =====================================
const tripDataLS = loadLs(KEY_LS);
if (tripDataLS) {
  tripData = tripDataLS;
  Object.entries(tripDataLS).forEach(([name, value]) => {
    //=====================================
    // Відновлення номера рейсу з LocalStorage
    //=====================================
    if (name === 'flightNumber' && typeof value === 'string' && value !== '') {
      if (flightNumberField) {
        flightNumberField.value = value;
        changeBgColor(flightNumberField);
      }
    }

    //=====================================
    // Відновлення дати і часу з LocalStorage
    //=====================================
    if (name === 'time' && typeof value === 'string' && value !== '') {
      const input = form?.querySelector(`.form-input[name="time"]`);
      if (input) {
        // Перевіряємо дату, якщо вона в минулому - не відновлюємо і очистимо
        if (
          new Date(value.replace(' ', 'T')).getDate() < new Date().getDate()
        ) {
          setTripData({ time: '' });
        } else {
          input.value = value;
          changeBgColor(input);
          setDepartureTime(value);
        }
      } else {
        // Якщо форми немає на сторінці — просто відновимо час у стані
        if (new Date(value.replace(' ', 'T')) >= new Date()) {
          setTripData({ time: value });
        }
      }
    }

    //=====================================
    // Відновлення адреси з LocalStorage
    //=====================================
    if (
      (name === 'from' || name === 'to') &&
      value &&
      typeof value === 'object' &&
      value.address
    ) {
      const input = form?.querySelector(`.form-input[name="${name}"]`);
      if (input) {
        input.value = value.address;
        setTripData({ [name]: value });
        changeBgColor(input);
      } else {
        // Якщо форми немає — лише відновлюємо стан
        setTripData({ [name]: value });
      }
    }
  });
}

// =====================================
// Слухач input (time)
// =====================================
if (inputTime)
  inputTime.addEventListener('input', () => {
    const time = inputTime.value.trim();
    changeInputsStyled(inputTime, time);
    setTripData({ time });
    setTripOrderData(tripData);
    setDepartureTime(time);
  });

// =====================================
// Слухачі input (from, to)
// =====================================
if (form)
  form.addEventListener('input', event => {
    const input = event.target;
    if (!input.classList.contains('form-input')) return;

    const { name, value } = input;

    // Очистка маркерів при редагуванні полів "from" і "to"
    if (name === 'from') {
      clearFromRoute();
      clearFromMarker();
    }
    if (name === 'to') {
      clearToRoute();
      clearToMarker();
    }

    // Збір даних з полів "from" і "to"
    if (name === 'from' || name === 'to') {
      changeInputsStyled(input, value.trim());
      setTripData({ [name]: { address: value } });
      setTripOrderData(tripData);
    }
  });

// =====================================
// Markers "from" and "to"
// =====================================
let fromMarker, toMarker;
let mapRef, MarkerRef;

const setFromMarker = place => {
  if (fromMarker) {
    fromMarker.setMap(null);
    fromMarker = null;
  }

  fromMarker = new MarkerRef({
    position: place.geometry.location,
    map: mapRef,
    label: 'A',
  });

  setFromForRoute(place);
};
const setToMarker = place => {
  if (toMarker) {
    toMarker.setMap(null);
    toMarker = null;
  }

  toMarker = new MarkerRef({
    position: place.geometry.location,
    map: mapRef,
    label: 'B',
  });
  setToForRoute(place);
};

const clearFromMarker = () => {
  if (fromMarker) {
    fromMarker.setMap(null);
    fromMarker = null;
  }
};
const clearToMarker = () => {
  if (toMarker) {
    toMarker.setMap(null);
    toMarker = null;
  }
};

// =====================================
// випадаючі списки з "особливими адресами"
// =====================================
function showDropdown(input) {
  // якщо інпуту або форми немає — пропускаємо
  if (!input || !form) return;
  const dropdown =
    input.name === 'from'
      ? form.querySelector('.dropdown_get-in')
      : form.querySelector('.dropdown_get-out');
  if (!input || !dropdown) return;

  insertsSpecialAddresses({ dropdown, specialAddresses, lang });

  const shouldShow = () =>
    document.activeElement === input && input.value.trim() === '';

  const update = () => {
    if (shouldShow()) dropdown.classList.add('visible');
    else dropdown.classList.remove('visible');
  };

  input.addEventListener('focus', update);
  input.addEventListener('input', update);
  input.addEventListener('blur', () => {
    // allow clicks inside dropdown before hide
    setTimeout(update, 150);
  });

  // prevent input losing focus when clicking dropdown items (so click works)
  dropdown.addEventListener('mousedown', e => e.preventDefault());

  // optional: clicking a dropdown-button fills input and closes menu
  dropdown.addEventListener('click', e => {
    const btn = e.target.closest('.dropdown-button');
    if (!btn) return;

    let address = '';

    if (btn.dataset.id === 'my-location') {
      btn.querySelector('.spinner')?.classList.remove('hidden');
      btn.querySelector('.pac-icon-my-location')?.classList.add('hidden');

      if (!navigator.geolocation) {
        notify('geolocation_not_supported', 'error');
        return;
      }
      navigator.geolocation.getCurrentPosition(position => {
        if (!position || !position.coords) {
          notify('geolocation_failed', 'error');
          return;
        }

        const locLiteral = {
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        };

        // Використовуємо geocoder, але беремо location з результату (це буде google.maps.LatLng)
        getPlaceByGeocode({ location: locLiteral }, place => {
          if (dropdown.classList.contains('dropdown_get-in')) {
            setFromMarker(place);
            setTripData({
              from: {
                address: place.formatted_address,
                coords: place.geometry.location.toJSON(),
              },
            });
          } else {
            setToMarker(place);
            setTripData({
              to: {
                address: place.formatted_address,
                coords: place.geometry.location.toJSON(),
              },
            });
          }
          changeInputsStyled(input, place.formatted_address);
          input.value = place.formatted_address;
          dropdown.classList.remove('visible');

          btn.querySelector('.spinner')?.classList.add('hidden');
          btn
            .querySelector('.pac-icon-my-location')
            ?.classList.remove('hidden');
        });
      });

      return;
    }

    address = specialAddresses[lang]?.find(
      a => a.id === btn.dataset.id
    )?.formatted_address;

    getPlaceByGeocode({ address }, place => {
      if (dropdown.classList.contains('dropdown_get-in')) {
        setFromMarker(place);
        setTripData({
          from: {
            address: place.formatted_address,
            coords: place.geometry.location.toJSON(),
          },
        });
      } else {
        setToMarker(place);
        setTripData({
          to: {
            address: place.formatted_address,
            coords: place.geometry.location.toJSON(),
          },
        });
      }
    });

    changeInputsStyled(input, address);
    input.value = address;
    dropdown.classList.remove('visible');
  });

  // initial state
  update();
}
showDropdown(fromInput);
showDropdown(toInput);

// global Esc to close
document.addEventListener('keydown', e => {
  if (e.key === 'Escape') {
    document
      .querySelectorAll('.dropdown_get-in.visible, .dropdown_get-out.visible')
      .forEach(d => d.classList.remove('visible'));
  }
});

// =====================================
// GOOGLE AUTOCOMPLETE
// =====================================

let fromAutocomplete, toAutocomplete;
export function setupInputs({ map, Marker, Autocomplete }) {
  mapRef = map;
  MarkerRef = Marker;

  if (!fromInput || !toInput) {
    console.error('Input elements not found!');
    return;
  }

  fromAutocomplete = new Autocomplete(fromInput, {
    types: ['geocode', 'establishment'],
    bounds: new google.maps.LatLngBounds(
      new google.maps.LatLng(48.5518, 12.0968), // Southwest
      new google.maps.LatLng(51.0557, 18.8663) // Northeast
    ),
  });
  toAutocomplete = new Autocomplete(toInput, {
    types: ['geocode', 'establishment'],
    bounds: new google.maps.LatLngBounds(
      new google.maps.LatLng(48.5518, 12.0968), // Southwest
      new google.maps.LatLng(51.0557, 18.8663) // Northeast
    ),
  });

  fromAutocomplete.addListener('place_changed', () => {
    const place = fromAutocomplete.getPlace();
    if (!place.geometry || !place.geometry.location) {
      console.warn('place.geometry.location missing');
      return;
    }
    setFromMarker(place);
    setTripData({
      from: {
        address: place.formatted_address,
        coords: place.geometry.location.toJSON(),
      },
    });
  });

  toAutocomplete.addListener('place_changed', () => {
    const place = toAutocomplete.getPlace();
    if (!place.geometry || !place.geometry.location) {
      console.warn('place.geometry.location missing');
      return;
    }
    setToMarker(place);
    setTripData({
      to: {
        address: place.formatted_address,
        coords: place.geometry.location.toJSON(),
      },
    });
  });

  map.addListener('click', onMapClick);

  setupButtons();
}

// =====================================
// Кнопки "Вибрати на карті"
// Дозволяємо клік по карті лише коли активна відповідна кнопка
// =====================================
let mapPickActive = false;
let mapPickTarget = null; // 'from' | 'to'

function setupButtons() {
  const fromPickBtn = document.querySelector('.map-pick-btn[data-pick="from"]');
  const toPickBtn = document.querySelector('.map-pick-btn[data-pick="to"]');

  const deactivatePick = () => {
    mapPickActive = false;
    mapPickTarget = null;
    fromPickBtn?.classList.remove('is-active');
    toPickBtn?.classList.remove('is-active');
    document.getElementById('map')?.classList.remove('map-pick-mode');
  };

  const activatePick = target => {
    mapPickActive = true;
    mapPickTarget = target; // 'from' | 'to'
    fromPickBtn?.classList.toggle('is-active', target === 'from');
    toPickBtn?.classList.toggle('is-active', target === 'to');
    document.getElementById('map')?.classList.add('map-pick-mode');
    notify(target === 'from' ? 'choose_pickup_A' : 'choose_pickup_B', 'info');
  };

  fromPickBtn?.addEventListener('click', () => {
    if (mapPickActive && mapPickTarget === 'from') return deactivatePick();
    activatePick('from');
  });
  toPickBtn?.addEventListener('click', () => {
    if (mapPickActive && mapPickTarget === 'to') return deactivatePick();
    activatePick('to');
  });

  // Якщо інтерфейс приховався/змінився — також скидаємо
  document.addEventListener('keydown', e => {
    if (e.key === 'Escape') deactivatePick();
  });

  // Експортуємо на випадок зовнішнього використання
  setupButtons.deactivatePick = deactivatePick;
}

// =====================================
// Додаємо клас для зміни курсора на карті
// =====================================
// legacy helper removed (inline activation now handled via activatePick)

// =====================================
// Вибір адреси на карті
// =====================================
function onMapClick(e) {
  if (!mapPickActive || (mapPickTarget !== 'from' && mapPickTarget !== 'to')) {
    return; // клік по карті ігноруємо, коли режим вибору не активний
  }
  const geocoder = new google.maps.Geocoder();
  geocoder.geocode({ location: e.latLng }, (results, status) => {
    if (status === 'OK' && results[0]) {
      const place = {
        geometry: { location: e.latLng },
        formatted_address: results[0].formatted_address,
      };
      if (mapPickTarget === 'from') {
        fromInput.value = place.formatted_address;
        changeInputsStyled(fromInput, place.formatted_address);
        setFromMarker(place);
        setTripData({
          from: {
            address: place.formatted_address,
            coords: place.geometry.location.toJSON(),
          },
        });
      } else {
        toInput.value = place.formatted_address;
        changeInputsStyled(toInput, place.formatted_address);
        setToMarker(place);
        setTripData({
          to: {
            address: place.formatted_address,
            coords: place.geometry.location.toJSON(),
          },
        });
      }
      // Після вибору точки — виходимо з режиму pick
      setupButtons.deactivatePick?.();
    }
  });
}

// =======================================
// Відновлення маркерів з localStorage
// =====================================
export const restoreMarkersFromLS = () => {
  const trip = loadLs(KEY_LS) || {};
  const { from, to } = trip;
  if (from && from?.coords) {
    const place = {
      geometry: {
        location: new google.maps.LatLng(from.coords.lat, from.coords.lng),
      },
      formatted_address: from.address,
    };
    setFromMarker(place);
  }
  if (to && to?.coords) {
    const place = {
      geometry: {
        location: new google.maps.LatLng(to.coords.lat, to.coords.lng),
      },
      formatted_address: to.address,
    };
    setToMarker(place);
  }
};

// =====================================
// Скидання tripData
// =====================================
export const resetTripData = () => {
  tripData = { ...initialTripData };
  saveLs(KEY_LS, tripData);
  setTripOrderData(tripData);
  clearFromMarker();
  clearToMarker();
  clearFromRoute();
  clearToRoute();
  if (inputTime) {
    inputTime.value = '';
    changeBgColor(inputTime, '#fff');
  }
  if (fromInput) {
    fromInput.value = '';
    changeBgColor(fromInput, '#fff');
  }
  if (toInput) {
    toInput.value = '';
    changeBgColor(toInput, '#fff');
  }
  if (flightNumberWrapper) flightNumberWrapper.style.display = 'none';
  if (flightNumberField) {
    flightNumberField.value = '';
    changeBgColor(flightNumberField, '#fff');
  }
};

// =====================================
// Слухач input id="flightNumberField"
// =====================================
flightNumberField?.addEventListener('input', e => {
  const raw = e.target.value;
  const trimmed = raw.trim();
  if (trimmed.length) {
    // Store original (raw) so user formatting preserved
    setTripData({ flightNumber: raw });
    changeBgColor(flightNumberField);
  } else {
    setTripData({ flightNumber: null });
    changeBgColor(flightNumberField, '#fff');
  }
});
